module.exports = __webpack_public_path__ + "asset/img/kong_no_content@2x.edb2f9c8.png";